import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogPanelComponentContent } from '@toro/common/shared/models/dialogs/DialogPanelComponentContent';

@Component({
  selector: 'alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AlertDialogComponent extends DialogPanelComponentContent {

  public userEmail: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    @Inject(DOCUMENT) private document: Document,
    public elementRef: ElementRef,
    private dialogReference: MatDialogRef<AlertDialogComponent>,
  ) {
    super(elementRef, true);
    this.document.body.classList.add('freeze');
  }

  /**
     * Encerra componente, habilita overflow e destroi dialogReference
     */
  public closeDialog() {
    this.document.body.classList.remove('freeze');
    this.close(this.dialogReference, null);
    this.dialogReference = null;
  }

}
